import { render } from "./Agents_Commissions.vue?vue&type=template&id=365c7bd6"
import script from "./Agents_Commissions.vue?vue&type=script&lang=js"
export * from "./Agents_Commissions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__